import { Config } from '#lib/constants/config.js';
import {
	ABOUT_US_FOOTER_LINK,
	JOBS_FOOTER_LINK,
} from '#lib/features/navigation/constants/footer-links.js';
import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';

// The site-wide footer: returned by the root server load, and rebuilt by the
// root universal load when SvelteKit renders the root error page without any
// server data.
export const getRootFooter = () => {
	const links: { label: string; href: string; newTab?: boolean }[] = [
		{ label: 'Privacy Policy', href: GlobalRoutes.PrivacyUk, newTab: true },
		JOBS_FOOTER_LINK,
		ABOUT_US_FOOTER_LINK,
	];

	return {
		listId: Config.NewsletterListIds.Homepage,
		links,
	};
};
